import { Component, HostBinding, Input, OnChanges } from '@angular/core';
import { IPresenter } from 'rev-shared/webrtc/Contract';
import { WebRtcListenerConnectionService } from 'rev-shared/webrtc/WebRtcListenerConnection.Service';
import { Subscription } from 'rxjs';
import { IProducerLayout } from '../../Contract';
import { ProducerService } from '../../Producer.Service';

import styles from './AudioPresenters.module.less';

@Component({
	selector: 'audio-presenters',
	templateUrl: './AudioPresenters.Component.html',
	host: {
		'[class]': 'styles.root'
	},
	standalone: false
})
export class AudioPresentersComponent implements OnChanges {
	@Input() public layout: IProducerLayout;

	@HostBinding('class.editable')
	@Input() public canEdit: boolean;

	public readonly styles = styles;
	public sub: Subscription;
	public presenters: IPresenter[];
	public shadowsStyles: { [presenterId: string]: string } = {};

	constructor(
		private readonly ProducerService: ProducerService,
		private readonly ListenerConnection: WebRtcListenerConnectionService
	) {}

	public ngOnInit(): void {
		this.sub = this.ListenerConnection.presenters.presenters$.subscribe(() => this.updatePresenters());
	}

	public ngOnChanges(): void {
		this.updatePresenters();
	}

	public ngOnDestroy(): void {
		this.sub?.unsubscribe();
	}

	public updatePresenters(): void {
		this.presenters = this.ListenerConnection.presenters.getLayoutPresenters(this.layout);
		this.shadowsStyles = this.presenters.reduce((acc, presenter) => {
			const vol = this.ListenerConnection.presenters.getVolume(presenter.id);
			acc[presenter.id] = this.getProfileShadow(vol);
			return acc;
		}, {});
	}

	public onClick(presenter: IPresenter): void {
		if(!this.canEdit) {
			return;
		}
		this.ProducerService.removePresenterFromPreview(presenter.id)
			.catch(e => console.error('AudioPresenters. Remove from preview error: ', e));
	}

	private getProfileShadow(volume: number): string {
		if(volume >= 0) {
			const blur = 15 * volume;
			const spread = 3 * volume;

			return `box-shadow: 0 0 ${blur}px ${spread}px var(--theme-primary-txt)`;
		}
	}

	public getShadow(presenter: IPresenter): any {
		return this.shadowsStyles[presenter.id];
	}
}
